/**
 * React Query query for AI roteiro generation history.
 */

import { useQuery } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { getAiJobs } from "../api/getAiJobs";
import type { AiJobRow } from "../types";

export function useRoteiroHistory() {
  const { client, isReady } = useSupabaseClient();
  return useQuery<AiJobRow[], Error>({
    queryKey: ["ai_jobs", "roteiros", isReady],
    queryFn: () => getAiJobs(client),
    enabled: isReady,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
  });
}
